import { PaymentTermOption } from "../../account/constants/dealer-basic-data";
import { Currency, GeneralBasicData } from "../../common/constants/general-basic-data";
import { PhoneNumber } from "../../common/models/address.model";
import { RentalMileageOption, RentalInsuranceOption, BookingStatus } from "../constants/rent-basic-data";


 export class BookingModif {

   id = 0;

   customerId = "";
   carId = "";
   offerId = '';

   customerDriving = true;
   withDriver = false;
   startDate = "";
   endDate = "";

   mileageOption: RentalMileageOption = RentalMileageOption.STANDARD;
   insuranceOption: RentalInsuranceOption  = RentalInsuranceOption.STANDARD;
   paymentTermOption: PaymentTermOption = PaymentTermOption.PAY_NOW;

   country = "";
   currency: Currency = GeneralBasicData.getDefaultCurrency();
   totalDays = 0; 

   insuranceDayRate = 0; 
   driverDayRate = 0; 
   carDayRate = 0; 

   insuranceAmount = 0; 
   driverAmount = 0; 
   carAmount = 0; 
   totalAmountToPay = 0; 

   driverCompany = "";
   driverFirstName = "";
   driverLastName = "";
   driverAgeMin = 0;

   driverEmail = "";
   driverPhoneNumber: PhoneNumber = new PhoneNumber();

   driverIdCardNo = "";
   notes = "";

   created = "";
   lastUpdated = "";
   createdBy = "";
   lastUpdatedBy = "";

   status: BookingStatus = BookingStatus.DRAFT;

   constructor(){
   }

 }
